export const FETCH_SEARCH_PAGE_INITIAL = "FETCH_SEARCH_PAGE_INITIAL";
export const FETCH_SEARCH_PAGE_SUCCESS = "FETCH_SEARCH_PAGE_SUCCESS";
export const FETCH_SEARCH_PAGE_FAILURE = "FETCH_SEARCH_PAGE_FAILURE";
